import { z } from "zod";
import { phoneNumberOptionalSchema } from "../utils/validationUtils";

export const userCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  username: z.string().min(1, "Username is required"),
  email: z.string().email("Invalid email"),
  roleId: z.string().min(1, "Role ID is required"),
  phoneNumber: phoneNumberOptionalSchema,
});

export const userUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  username: z.string().min(1, "Username is required").optional(),
  email: z.string().email("Invalid email").optional(),
  roleId: z.string().min(1, "Role ID is required").optional(),
  phoneNumber: phoneNumberOptionalSchema,
  isActive: z.boolean().optional(),
});

export type UserCreateFormData = z.infer<typeof userCreateSchema>;
export type UserUpdateFormData = z.infer<typeof userUpdateSchema>;

export interface User {
  id: string;
  name: string;
  username?: string;
  email: string;
  tenantId?: string;
  roleId: string;
  phoneNumber?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  role: string;
  permissions: string[];
}
